import React from "react";
import Icon from "components/AppIcon";
import { SparklineChart } from "./SparklineChart";

export default function MetricsStrip({ metrics: metricsProp }) {
  const colorByMetricId = {
    pipeline: "#1E40AF",
    winrate: "#10B981",
    dealsize: "#8B5CF6",
    cycle: "#F59E0B",
  };

  const metricList = (metricsProp || []).map((metric) => ({
    ...metric,
    color: metric?.color || colorByMetricId?.[metric?.id] || "#1E40AF",
  }));

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {metricList?.map((m) => (
        <div
          key={m?.id}
          className="card-base p-4 md:p-5 flex flex-col gap-3 hover:shadow-lg transition-shadow duration-200"
          style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
        >
          <div className="flex items-center justify-between">
            <div
              className="flex items-center justify-center rounded-lg"
              style={{ width: 36, height: 36, background: `${m?.color}18` }}
            >
              <Icon name={m?.icon} size={18} color={m?.color} />
            </div>
            <span
              className={`flex items-center gap-1 text-xs font-medium font-caption px-2 py-0.5 rounded-full ${
                m?.positive ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600"
              }`}
            >
              <Icon name={m?.positive ? "TrendingUp" : "TrendingDown"} size={11} color="currentColor" />
              {m?.change}
            </span>
          </div>
          <div>
            <p className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>
              {m?.label}
            </p>
            <p className="text-xl md:text-2xl font-heading font-bold mt-0.5" style={{ color: "var(--color-foreground)" }}>
              {m?.value}
            </p>
          </div>
          <SparklineChart data={m?.sparkData} color={m?.color} />
        </div>
      ))}
    </div>
  );
}